import {
  RefObject,
  SyntheticEvent,
  useCallback,
  useEffect,
  useRef,
} from 'react';

export default <T extends HTMLElement = HTMLElement>(
  ref: RefObject<T>,
  callback: (event: SyntheticEvent<T, Event>) => void,
) => {
  // https://legacy.reactjs.org/docs/hooks-faq.html#how-to-read-an-often-changing-value-from-usecallback
  // to avoid passing callback as part of the dependency array of the listener
  const callbackRef = useRef<typeof callback | null>(null);
  useEffect(() => {
    callbackRef.current = callback;
  });

  const listener: EventListener = useCallback(
    (event) => {
      const el = ref?.current;
      if (!el || el.contains((event?.target as Node) || null)) {
        return;
      }

      if (event) {
        callbackRef.current?.(event as unknown as SyntheticEvent<T, Event>);
      }
    },
    [ref],
  );

  useEffect(() => {
    document.addEventListener('mousedown', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
    };
  }, [listener]);
};
